import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';

const ORGANISM_NAME = 'info-hero';
export default class InformationalHero extends React.Component {
  constructor(props) {
    super(props);
    this.handleFirstTab= this.handleFirstTab.bind(this);

  }
  componentDidMount() {
    window.addEventListener('keydown', this.handleFirstTab);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleFirstTab);
  }
    /* eslint-disable */
    handleFirstTab(e) {
      if (e.keyCode === 9) { // the "I am a keyboard user" key
        document.body.classList.add('user-is-tabbing');
      }
    }
   /* eslint-enable */

  render() {
    const {topics} = this.props;
    const refID = this.props.refID;
    const getPopContent = getContent('staticContent');
    const palBlue = 'circle at 0 0, #0070ba, #1546a0';
    const enterpriseSolutionsID = "enterprise-solutions";
    let topic = _.find(topics, (topic)=>topic.ref_id===refID);
    if(!topic) {
      topic = _.compact( _.map(topics, (topic) => {
        if(topic.categories) {
          return _.find(topic.categories, (category)=>category.ref_id===refID);
        }
        return false;
      }))[0];
    }
    var topicHeading;
    var topicDescription;
    if(refID === 'most-popular-articles' && this.props.isPopArticleEnabled){
      topicHeading = getPopContent('brc.mostPopularArticles');
      topicDescription = '';
    }
    else{
      topicHeading = topic.text;
      topicDescription = topic.description;
    }

    let contactSalesBtnText = "";
    let enterpriseCategoriesExist = false;

    if(topic && topic.ref_id && topic.ref_id === enterpriseSolutionsID){
      contactSalesBtnText = getPopContent('brc.contactSalesBtnText');
    }

    if(topics.length!==0){
      const result = topics.filter((item)=>item.ref_id === enterpriseSolutionsID);
      const enterpriseCategoriesLists = result.length!==0 && result[0] && result[0].categories && result[0].categories.length!==0? result[0].categories: [];
      if(topic && topic.ref_id && enterpriseCategoriesLists.length!==0){
        const enterpriseSubCategorie = enterpriseCategoriesLists.filter((item)=>{
          if(item.ref_id === topic.ref_id){
            return item;
          }
        });
        if(enterpriseSubCategorie.length!==0){
          contactSalesBtnText = getPopContent('brc.contactSalesBtnText');
          enterpriseCategoriesExist = true;
        }
      }
    }
    
    const backgroundImageStyle =
    topic && topic.url ? {
      backgroundImage: `url(${topic.url})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundColor: '#0070ba'
    } : {
      backgroundColor: '#0070ba',
      backgroundImage: `radial-gradient(${palBlue})`
    };

    const fontChange = this.props.country === 'vn' && this.props.locale === 'vi_VN' ? 'vnFont' : this.props.country === 'jp' && this.props.locale === 'ja_JP'? 'jpFont': '';
    const contactSalesBtnDisplayCountryLists = ['us','au','ca'];
    return (
      <div id= "category-HeroImage-container" className="categoryHeroImageContainer">
      <section
        data-building-block="organism"
        className={ORGANISM_NAME}
        style={backgroundImageStyle}
      >
        <div className="container">
          <div className="row">
            <div className={`${ORGANISM_NAME}__container col-xs-12 col-lg-9 center-block text-xs-center`}>
            <h1 className={`${ORGANISM_NAME}__headline h1 ${fontChange}`}>{topicHeading}</h1>
            <p className={`${ORGANISM_NAME}__paragraph`}>{topicDescription}</p>
            </div>
          </div>
        </div>
        {((topic && topic.ref_id && topic.ref_id === enterpriseSolutionsID) || enterpriseCategoriesExist) && contactSalesBtnDisplayCountryLists.includes(this.props.country)?
            <div className="contact-sales-btn-wrapper">
            <a
            target="_blank"
            role="button"
            className="contact-sales-btn pypl-btn"
            href={`https://www.paypal.com/${this.props.country}/enterprise/contact-sales?utm_source=brc_enterprise`}
          >
            {contactSalesBtnText}
            </a></div>:null
        }
      </section>
      </div>
    );
  }
}

InformationalHero.propTypes = {
  topics: PropTypes.array,
  refID: PropTypes.string
};
